const initialState = {
  loading: false,
  data: null,
  error: null,
};

const advertisementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ADVERTISEMENTS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_ADVERTISEMENTS_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_ADVERTISEMENTS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default advertisementsReducer;
